export default "__VITE_ASSET__kkPMFtHy__"